export * from '@taqueria/protocol/out/types/PositionalArg';
